// extracted by mini-css-extract-plugin
export default {"main":"styles_main__WP0O-","header":"styles_header__qBoCL","headerBox":"styles_headerBox__SWNWK"};